import url from "../../../utils/api/url";
import Service from "../../../utils/api/service";
import Helper from "../../../utils/global/func";
import XLSX from "xlsx";
import moment from "moment";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _debounce from "lodash.debounce";

export default {
  name: "ListReportOrderDownload",
  data() {
    return {
      isLoading: false,
      isGenerating: false,
      isExporting: false,
      isGenerated: false,
      isCustomerDropdown: false,
      data: {
        customerGroups: this.$master?.customerGroups || [],
        customers: [],
        paymentMethods: this.$master?.paymentMethods || [],
        orderStatus: this.$master?.orderStatuses || [],
      },
      body: {
        customerGroupId: "",
        customerId: "",
        customerName: "",
        code: "",
        paymentMethodId: "",
        orderStatus: "",
        minTotal: "",
        maxTotal: "",
        startDate: "",
        endDate: "",
        provider: "",
        deliveryStatusId: "",
      },
      table: {
        name: "",
        headers: [],
        body: [],
      },
      // filter warehouse
      branchs:
        (this.$store?.state?.accountInfo?.branches && [
          { id: "", name: "All Permission Branches" },
          ...this.$store?.state?.accountInfo?.branches,
        ]) ||
        [],
      allBranchs:
        (this.$store?.state?.accountInfo?.branches && [
          { id: "", name: "All Permission Branches" },
          ...this.$store?.state?.accountInfo?.branches,
        ]) ||
        [],
      debouncedOnSearchBranchs: null,
      branchId: "",
      providers: this.$provider?.orderProviderEnum,
      deliveryStatuses: [
        { id: "", name: "All Delivery Status" },
        ...(this.$masterCrm?.CrmDeliveryStatus || []),
      ],
    };
  },
  components: { Multiselect, DatePicker },
  created() {
    this.getCustomers("");

    this.debouncedOnSearchBranchs = _debounce(
      this.handleBranchSearchChange,
      500,
    );
  },
  computed: {
    debouncedOnSearchCustomers() {
      return _debounce(this.getCustomers, 500);
    },
  },
  methods: {
    handleBranchSearchChange(query) {
      if (!query || query.trim() === "") {
        this.branchs = [...this.allBranchs];
        return;
      }

      this.filterBranch(this.allBranchs, query);
    },

    filterBranch(data, search) {
      if (!search || search.trim() === "") {
        this.branchs = data;
        return;
      }

      const normalizedSearch = search.toLowerCase().trim();

      const items = data.filter((item) => {
        const matchName = item.name?.toLowerCase().includes(normalizedSearch);
        const matchCode = item.code?.toLowerCase().includes(normalizedSearch);

        return matchName || matchCode;
      });

      this.branchs = items;
    },

    onBranchSelected() {
      this.generateReport();
    },

    async getCustomers() {
      this.isLoading = true;
      let param = "?search=" + this.body.customerName;
      Service.getCustomers(param).then((response) => {
        this.isLoading = false;
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.getCustomer();
              }
            });
          } else {
            this.$toasted.show(response.message);
          }
        } else {
          this.data.customers = response.data;
        }
      });
    },

    onSelectCustomer(customerIndex) {
      let customer = this.data.customers[customerIndex];
      this.body.customerId = customer.id;
      this.body.customerName = customer.firstName + " " + customer.lastName;
      this.isCustomerDropdown = false;
    },

    getFullImage(path) {
      return Helper.getFullImage(path);
    },

    checkParamSign(param) {
      return param.includes("?") ? "&" : "?";
    },

    generateReport(type) {
      if (type == "export") this.isExporting = true;
      else this.isGenerating = true;

      let token = localStorage.getItem(this.$helper?.tokenEnum()?.access_token)
        ? localStorage.getItem(this.$helper?.tokenEnum()?.access_token)
        : "";

      let header = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
      };

      let queryParam = "";

      let branchIds = this.branchId?.id
        ? [this.branchId.id]
        : this.$store?.state?.accountInfo?.branches?.map((item) => item?.id) ||
          [];
      let queryString = branchIds
        .filter(Boolean)
        .map((id) => `branchIds=${id}`)
        .join("&");
      queryParam = `&${queryString}`;

      let param = `/sale-order/filter?download=true${queryParam}`;
      let body = this.body;
      if (this.body.customerGroupId) {
        param = param + "&customerGroupId=" + this.body.customerGroupId;
      }
      if (this.body.code) {
        param = param + "&cardCode=" + this.body.code;
      }
      if (body.customerName) {
        param = param + "&accountId=" + body.customerId;
      }
      if (body.paymentMethodId) {
        param = param + "&paymentMethodId=" + body.paymentMethodId;
      }
      if (body.orderStatus) {
        param = param + "&orderStatusId=" + body.orderStatus;
      }
      if (body.minTotal) {
        param = param + "&minTotal=" + body.minTotal;
      }
      if (body.maxTotal) {
        param = param + "&maxTotal=" + body.maxTotal;
      }
      if (body.startDate) {
        param = param + "&startDate=" + body.startDate + "T00:00:00.000";
      }
      if (body.endDate) {
        param = param + "&endDate=" + body.endDate + "T23:59:59.999";
      }
      if (body.provider) {
        param = param + "&provider=" + body.provider;
      }
      if (body.deliveryStatusId) {
        param = param + "&deliveryStatusId=" + body.deliveryStatusId;
      }

      this.$axios({
        url: url.report + param,
        method: "GET",
        headers: header.headers,
        responseType: "blob", // important
      })
        .then((response) => {
          this.isGenerating = false;
          this.isGenerated = true;
          if (response.statusCode) {
            if (response.statusCode === "403") {
              this.isGenerated = false;
              this.$toasted.show(response.message);
            }
          } else {
            const blobfile = new Blob([response.data]);
            if (type == "export") {
              this.isExporting = false;
              this.exportFile(blobfile);
            } else {
              this.isGenerating = false;
              this.readFileToTable(blobfile);
            }
          }
        })
        .catch(() => {
          this.isGenerating = false;
          this.isGenerated = false;
          this.$toasted.show("No Data");
        });
    },

    exportFile(blobfile) {
      let filename = "SaleOrder Report " + new Date();
      const url = window.URL.createObjectURL(blobfile);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename + ".xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    readFileToTable(blobfile) {
      return new Promise((resolve, reject) => {
        this.table.headers.length = 0;
        this.table.body.length = 0;

        const reader = new FileReader();

        reader.onload = (event) => {
          try {
            const data = event.target?.result;

            if (!(data instanceof ArrayBuffer)) {
              throw new Error("Invalid Excel file data");
            }

            const workbook = XLSX.read(data, {
              type: "array",
              cellDates: true,
            });

            if (!workbook.SheetNames.length) {
              throw new Error("Excel file has no worksheets");
            }

            const worksheet = workbook.Sheets[workbook.SheetNames[0]];

            if (!worksheet || !worksheet["!ref"]) {
              throw new Error("Worksheet is empty");
            }

            /**
             * Convert worksheet to a 2D array.
             *
             * Example:
             *
             * [
             *   ["Delivery Status", "Start Deliver Date", ...],
             *   ["Waiting To Deliver", "", ...],
             *   ["On Delivery", "24-Apr-2026 02:12 PM", ...]
             * ]
             */
            const rows = XLSX.utils.sheet_to_json(worksheet, {
              header: 1,
              defval: "",
              raw: false,
            });

            if (!rows.length) {
              resolve({
                headers: [],
                body: [],
              });

              return;
            }

            const headers = rows[0].map((header) =>
              String(header ?? "").trim(),
            );

            const body = rows
              .slice(1)
              .filter((row) =>
                row.some(
                  (value) =>
                    value !== null &&
                    value !== undefined &&
                    String(value).trim() !== "",
                ),
              );

            this.table.headers.push(...headers);
            this.table.body.push(...body);

            resolve({
              headers,
              body,
            });
          } catch (error) {
            console.error("Failed to parse Excel file:", error);
            reject(error);
          }
        };

        reader.onerror = () => {
          const error = new Error("Failed to read Excel file");

          console.error(error);
          reject(error);
        };

        reader.readAsArrayBuffer(blobfile);
      });
    },

    clickOutsideCustomerTextbox() {
      this.isCustomerDropdown = false;
    },

    onUnselectCustomer() {
      this.body.customerId = "";
      this.body.customerName = "";
    },

    ExcelDateToJSDate(serial) {
      var utc_days = Math.floor(serial - 25569);
      var utc_value = utc_days * 86400;
      var date_info = new Date(utc_value * 1000);

      var fractional_day = serial - Math.floor(serial) + 0.0000001;

      var total_seconds = Math.floor(86400 * fractional_day);

      var seconds = total_seconds % 60;

      total_seconds -= seconds;

      var hours = Math.floor(total_seconds / (60 * 60));
      var minutes = Math.floor(total_seconds / 60) % 60;

      let date = new Date(
        date_info.getFullYear(),
        date_info.getMonth(),
        date_info.getDate(),
        hours,
        minutes,
        seconds,
      );
      return moment(date).format("DD-MMM-YYYY h:mm A");
    },

    nullValue(string) {
      if (string == "") {
        string = "N/A";
      }
      return string;
    },

    // handlemouseup: function () {
    //   this.boxsearch.focused = false;
    // },
  },

  // beforeMount() {
  //   document.body.addEventListener("mouseup", this.handlemouseup);
  // },
  // beforeDestroy() {
  //   document.body.removeEventListener("mouseup", this.handlemouseup);
  // },
};
